import React from "react";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Provider as ReduxProvide } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor, useAppSelector } from "./store";
import { ToastContainer } from "react-toastify";
import { getFirebaseToken, onForegroundMessage } from "services/firebase";
import { I18nextProvider } from "react-i18next";
import { useTranslation } from 'react-i18next'

import PageRouter from "setup/PageRouter";
import OverlayLoading from "./components/OverlayLoading";
import { ConfigProvider, message } from "antd";
import SocketProvider from "./websocket";
import i18next from './locales/index';

import enUS from 'antd/es/locale/en_US'
import thTH from 'antd/es/locale/th_TH'
import { colors } from "@mui/material";

function App() {
  const queryClient = new QueryClient();

  const { i18n } = useTranslation()
  const isThai = i18n.language === 'th'



  React.useEffect(() => {
    getFirebaseToken();

    onForegroundMessage()
      .then((payload: any) => {
        console.log("Received foreground message: ", payload);
        const {
          notification: { title, body },
        } = payload;

       // message.info("New notification: " + title + " - " + body);
      })
      .catch((err) =>
        console.log(
          "An error occured while retrieving foreground message. ",
          err
        )
      );
  }, []);

  return (
    <ReduxProvide store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <SocketProvider>
          <I18nextProvider i18n={i18next}>
            <ConfigProvider
             locale={isThai ? thTH : enUS}
              theme={{
                token: {
                  colorPrimary: "#016BB7",
                  fontFamily: "Prompt, Roboto, sans-serif",
                  borderRadius: 4,
                  boxShadow: "#84a5b5",
                  colorLink: "#016BB7",
                  colorLinkHover: "#84a5b5",
                
                },

              }}
            >
              <Home />
            </ConfigProvider>
            </I18nextProvider>
          </SocketProvider>
          <ReactQueryDevtools initialIsOpen={false} position="left" /> 
        </QueryClientProvider>
      </PersistGate>
    </ReduxProvide>
  );
}

const Home = () => {
  const { loading } = useAppSelector((state) => state.loading);

  return (
    <>
      {/* spin */}
      <OverlayLoading open={loading} />
      <ToastContainer />
      <PageRouter />
    </>
  );
};

export default App;
